export class Download {
  hoId: string;
  es: boolean; // added check for is segment enabled for export
  invoices: any[];
}
